import script from "./Faces.vue?vue&type=script&setup=true&lang=ts"
export * from "./Faces.vue?vue&type=script&setup=true&lang=ts"

import "./Faces.vue?vue&type=style&index=0&id=34412786&scoped=true&lang=scss"

import exportComponent from "E:\\work\\EEEEE\\okpay\\ipay-imi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34412786"]])

export default __exports__